import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { FiMenu, FiLogOut, FiUser, FiBell, FiBellOff } from 'react-icons/fi';
import { toast } from 'react-toastify';

const Header = ({ toggleSidebar, lowStockAlertEnabled = true, onToggleLowStockAlert }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [showDropdown, setShowDropdown] = useState(false);

  const handleLogout = () => {
    logout();
    toast.success('Logged out successfully');
    navigate('/login');
  };

  return (
    <header className="bg-white shadow-md h-16 fixed top-0 right-0 left-0 lg:left-64 z-10">
      <div className="h-full px-4 flex items-center justify-between">
        {/* Left side */}
        <div className="flex items-center space-x-4">
          {/* Mobile menu button */}
          <button
            onClick={toggleSidebar}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition"
          >
            <FiMenu className="w-6 h-6 text-gray-600" />
          </button>

          <div>
            <h2 className="text-xl font-bold text-gray-800">
              Welcome, {user?.name}!
            </h2>
            {/* <p className="text-sm text-gray-500">
              {new Date().toLocaleDateString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </p> */}
          </div>
        </div>

        {/* Right side */}
        <div className="flex items-center space-x-4">
          {/* Low stock alert toggle */}
          <button
            onClick={onToggleLowStockAlert}
            title={lowStockAlertEnabled ? 'Low stock alerts: ON (click to turn off)' : 'Low stock alerts: OFF (click to turn on)'}
            className={`relative p-2 rounded-lg transition ${lowStockAlertEnabled ? 'hover:bg-orange-100' : 'hover:bg-gray-100'}`}
          >
            {lowStockAlertEnabled ? (
              <>
                <FiBell className="w-6 h-6 text-orange-600" />
                <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
              </>
            ) : (
              <FiBellOff className="w-6 h-6 text-gray-400" />
            )}
          </button>

          {/* User dropdown */}
          <div className="relative">
            <button
              onClick={() => setShowDropdown(!showDropdown)}
              className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-100 transition"
            >
              <div className="w-10 h-10 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full flex items-center justify-center">
                <FiUser className="w-5 h-5 text-white" />
              </div>
              <div className="hidden md:block text-left">
                <p className="text-sm font-semibold text-gray-800">{user?.name}</p>
                <p className="text-xs text-gray-500 capitalize">{user?.role}</p>
              </div>
            </button>

            {/* Dropdown menu */}
            {showDropdown && (
              <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg py-2 z-50">
                <div className="px-4 py-2 border-b">
                  <p className="text-sm font-semibold text-gray-800">{user?.name}</p>
                  <p className="text-xs text-gray-500">{user?.email}</p>
                </div>
                <button
                  onClick={handleLogout}
                  className="w-full flex items-center space-x-2 px-4 py-2 text-sm text-red-600 hover:bg-red-50 transition"
                >
                  <FiLogOut className="w-4 h-4" />
                  <span>Logout</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
